const BikeIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M11.167 9.667a2.33 2.33 0 0 1-1.333 2.099v-2.1c0-.55-.45-1-1-1h-.667c-.55 0-1 .45-1 1v2.1a2.33 2.33 0 0 1-1.333-2.1v-2c0-.684.303-1.319.81-1.758a2.653 2.653 0 0 0 3.712 0c.508.44.811 1.074.811 1.759v2Zm-2.667-7c.736 0 1.334.598 1.334 1.333S9.236 5.333 8.5 5.333A1.335 1.335 0 0 1 7.167 4c0-.735.598-1.333 1.333-1.333Zm4.667.666h-2.095a2.663 2.663 0 0 0-2.572-2 2.663 2.663 0 0 0-2.571 2H3.834a.666.666 0 1 0 0 1.334h2.095c.007.028.017.056.026.085A3.654 3.654 0 0 0 4.5 7.667v2a3.672 3.672 0 0 0 2.667 3.524v.476c0 .55.45 1 1 1h.667c.55 0 1-.45 1-1v-.476A3.672 3.672 0 0 0 12.5 9.667v-2a3.654 3.654 0 0 0-1.454-2.915c.008-.029.019-.057.026-.085h2.095a.666.666 0 1 0 0-1.334Z"
            clipRule="evenodd"
        />
    </svg>
);
export default BikeIcon;
